import { responseCodes, commonConstants } from "../_constants";
import { accountConstants } from "../_constants";
("use strict");

import { from, of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import {
  mergeMap,
  catchError,
  map,
  concatMap,
  switchMap,
  filter,
} from "rxjs/operators";
import { getRequestHeader } from "../../_helpers/request.header";
import { payloadFormatter } from "../../_helpers/encryption.helper";
import {
  ajaxError,
  payloadEncryptionFail,
  payloadEncryptionSuccess,
} from "../_actions";
import {
  accountListComplete,
  accountListError,
  accountDetailsComplete,
  accountDetailsError,
  ePassbookListComplete,
  ePassbookListError,
  accountHistoryListComplete,
  accountHistoryListError,
  eligibleCasaListComplete,
  eligibleCasaListError,
  savingAccountsOpenInitiateComplete,
  savingAccountsOpenInitiateError,
  savingAccountsOtpResendComplete,
  savingAccountsOtpResendError,
  savingAccountsOtpConfirmationComplete,
  savingAccountsOtpConfirmationError,
  savingAccountsReceiptComplete,
  savingAccountsReceiptError,
  downloadAccountStatementComplete,
  downloadAccountStatementError,
} from "../_actions/account.actions";
import {
  downloadBlobFile,
  getResponseContentType,
  parseStatementJsonFailure,
  normalizeStatementDownloadError,
} from "../../_helpers/support.services";

export const accountListsEpic = (actions$) =>
  actions$.pipe(
    ofType(accountConstants.ACCOUNT_LIST_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/account/getAccountLists",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) => accountListComplete(ajaxResponse.response)),
          catchError((error) => of(accountListError(error), ajaxError(error))),
        );
    }),
  );

export const ePassbookListEpic = (actions$) =>
  actions$.pipe(
    ofType(accountConstants.EPASSBOOK_LIST_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/account/getEpassbookList",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) => ePassbookListComplete(ajaxResponse.response)),
          catchError((error) =>
            of(ePassbookListError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const accountDetailsEpic = (actions$) =>
  actions$.pipe(
    ofType(accountConstants.ACCOUNT_DETAILS_REQUEST),
    mergeMap(async (action) => {
      try {
        const payload = await from(
          payloadFormatter(action.payload, "/api/account/getAccountDetails"),
        ).toPromise();
        return payloadEncryptionSuccess(payload, action.payload);
      } catch (error) {
        return payloadEncryptionFail(error);
      }
    }),
    filter((action) => action.encryptedPayload !== undefined),
    switchMap((action) => {
      return ajax
        .post(
          "/api/account/getAccountDetails",
          action.encryptedPayload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) => accountDetailsComplete(ajaxResponse.response)),
          catchError((error) =>
            of(accountDetailsError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const accountHistoryListEpic = (actions$) =>
  actions$.pipe(
    ofType(accountConstants.ACCOUNT_HISTORY_LIST_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/account/getAccountHistoryList",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            accountHistoryListComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(accountHistoryListError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const eligibleListEpic = (actions$) =>
  actions$.pipe(
    ofType(accountConstants.GET_ELIGIBLE_CASA_LIST_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/account/eligibleCasaList",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            eligibleCasaListComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(eligibleCasaListError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const savingAccountsOpenInitiateEpic = (actions$) =>
  actions$.pipe(
    ofType(accountConstants.SAVING_ACCOUNTS_OPEN_INITIATE_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/account/savingAccountsOpenInitiate",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            savingAccountsOpenInitiateComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(savingAccountsOpenInitiateError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const savingAccountsOtpResendEpic = (actions$) =>
  actions$.pipe(
    ofType(accountConstants.SAVING_ACCOUNTS_OTP_RESEND_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/account/savingAccountsOtpResend",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            savingAccountsOtpResendComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(savingAccountsOtpResendError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const savingAccountsOtpConfirmationEpic = (actions$) =>
  actions$.pipe(
    ofType(accountConstants.SAVING_ACCOUNTS_OTP_CONFIRMATION_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/account/savingAccountsOtpConfirmation",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            savingAccountsOtpConfirmationComplete(ajaxResponse.response),
          ),

          catchError((error) => {
            {
              if (
                !error?.response ||
                ![
                  responseCodes.SUCCESS_CODE,
                  responseCodes.SAVING_ACCOUNT_OPENING_FUNDS_NOT_INITIATED,
                  responseCodes.SAVING_ACCOUNT_OPENING_TRANSFER_TIMEOUT,
                  responseCodes.SAVING_ACCOUNT_OPENING_FAILED,
                  responseCodes.OTP_FAILED,
                  responseCodes.OTP_BLOCKED,
                  responseCodes.OTP_EXPIRED,
                ].includes(error?.response?.statusCode)
              ) {
                return of(
                  savingAccountsOtpConfirmationError({
                    responseCode: responseCodes.SAVING_ACCOUNT_OPENING_FAILED,
                  }),
                );
              }
              if (
                error?.response?.statusCode &&
                error?.response?.statusCode !==
                  responseCodes.SAVING_ACCOUNT_OPENING_FAILED &&
                error?.response?.statusCode !==
                  responseCodes.SAVING_ACCOUNT_OPENING_FUNDS_NOT_INITIATED &&
                error?.response?.statusCode !==
                  responseCodes.SAVING_ACCOUNT_OPENING_TRANSFER_TIMEOUT
              ) {
                return of(ajaxError(error));
              } else {
                return of(
                  savingAccountsOtpConfirmationError(
                    error?.response?.errorResponse,
                  ),
                );
              }
            }
          }),
        );
    }),
  );

export const savingAccountsReceiptEpic = (actions$) =>
  actions$.pipe(
    ofType(accountConstants.SAVING_ACCOUNTS_RECEIPT_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/account/savingAccountsReceipt",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            savingAccountsReceiptComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(savingAccountsReceiptError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const downloadAccountStatementEpic = (actions$) =>
  actions$.pipe(
    ofType(accountConstants.DOWNLOAD_ACCOUNT_STATEMENT_REQUEST),
    switchMap((action) =>
      ajax({
        body: action.payload,
        url: "/api/account/downloadStatement",
        method: "POST",
        responseType: "blob",
        headers: getRequestHeader(commonConstants.REQUEST_HEADER_METHOD_UPLOAD),
      }).pipe(
        concatMap(async (ajaxResponse) => {
          const blob = ajaxResponse.response;
          const contentType = getResponseContentType(
            ajaxResponse.xhr,
            blob,
          );

          const jsonFailure = await parseStatementJsonFailure(
            blob,
            contentType,
          );
          if (jsonFailure) {
            throw jsonFailure;
          }

          downloadBlobFile(
            action.payload.startDate +
              "_" +
              action.payload.endDate +
              "_" +
              action.payload.accountNumber +
              "_account_statement.pdf",
            ajaxResponse.response,
          );

          return downloadAccountStatementComplete({
            status: "success",
          });
        }),
        catchError((error) =>
          from(normalizeStatementDownloadError(error)).pipe(
            mergeMap((normalized) =>
              of(
                downloadAccountStatementError(normalized),
                ajaxError(normalized),
              ),
            ),
          ),
        ),
      ),
    ),
  );
